module.exports = __webpack_public_path__ + "img/shejishi.b873a8f0.png";